import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDuplicateDate',
})
export class IsDuplicateDatePipe implements PipeTransform {
  transform(date: string | null | undefined, allDates: string[] | null | undefined): boolean {
    if (!date || !allDates || allDates.length < 2) {
      return false;
    }

    let count = 0;

    for (const d of allDates) {
      if (d === date) {
        count++;
        if (count > 1) {
          return true;
        }
      }
    }

    return false;
  }
}
